export default __webpack_public_path__ + "img/ftDpduaO.13743d01.svg";